export function ProgressTrail({ current, total }: { current: number; total: number }) {
  const safeTotal = Math.max(total, current, 1);
  const progress = Math.min(100, Math.round((current / safeTotal) * 100));

  return (
    <div className="progress-trail" aria-label={`排查进度，第 ${current} 步，共约 ${safeTotal} 步`}>
      <div className="progress-meta">
        <span>排查轨迹</span>
        <span>
          {current} / 约 {safeTotal}
        </span>
      </div>
      <div className="progress-track" aria-hidden="true">
        <span style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
}
